import api from "@/plugins/api";
const PATH = {
    contact: "/portal/contacts/filter-metadata",
    organisation: "/portal/organisations/filter-metadata",
    resident: "/residents/filter-metadata",
    socialCaseFile: "/social-case-files/filter-metadata",
};
/**
 * Fetches the OP-6491 filter-metadata catalog from the BFF.
 *
 * Hits `GET /api/v1/portal/{contacts|organisations}/filter-metadata` (OPHUB) or
 * `GET /api/v1/{residents|social-case-files}/filter-metadata` (OPSOL, OP-8517 / OP-8666) (the axios base URL
 * already carries the `/api/v1/` prefix). Passing `unwrapEnvelope: true` triggers the response
 * interceptor to unwrap the `ApiResponse<FilterMetadataResponse>` envelope, so `response.data`
 * is the catalog payload directly (mirrors `contactApi.getContactById`).
 */
export async function getFilterMetadata(entity) {
    const response = await api.get(PATH[entity], {
        unwrapEnvelope: true,
    });
    return response.data;
}
